// Tab 相关处理
const tabs = (state = { activeKey: null, tabPanes: [] }, action) => {
  const { tabPanes } = state;
  switch (action.type) {
    // 新建 TAB
    case 'ADD_TAB_PANE':
      // 防止重复添加
      var tabPane = action.tabPane;
      if (tabPanes.find(tabInfo => tabInfo.key === tabPane.key)) {
        return Object.assign({}, state, {
          activeKey: tabPane.key
        });
      }

      // 为同名菜单加入后缀名(-01、-02)以此类推
      // 例子：
      // 新打开TAB标题名：手术耗材
      // 已打开TAB标题数组
      // [{ title: '手术耗材' }, { title: '手术耗材AAA' }, { title: '手术耗材-02' }, { title: 'BBB手术耗材' },
      // { title: '手术耗材-03' }, { title: 'CCC手术耗材DDD' }, { title: '手术EEE耗材' }, { title: '手术耗材-FFF' }]

      // 1、获取已新菜单为开头的TAB
      // result的结果：[{ title: '手术耗材' }, { title: '手术耗材AAA' }, { title: '手术耗材-02' }, { title: '手术耗材-03' }, { title: '手术耗材-FFF' }]
      var result = tabPanes.filter(tabInfo => tabInfo.title.indexOf(tabPane.title) === 0);

      // 获取当前打开TAB的title以外的字符串（跟tabPane.title完全一致的返回0、以外字符串为(02)的返回2、为其他无法转换成数字的字符串返回0）
      // suffixList的结果：[0, -1, 2, 3, -1]
      var suffixList = result.map(rs => {
        let element = -1;
        if (rs.title === tabPane.title) {
          element = 0;
        } else {
          const suffix = rs.title.substr(tabPane.title.length + 1);
          if (!isNaN(parseInt(suffix))) {
            element = parseInt(suffix);
          }
        }

        return element;
      });

      // 数组从小到大排序
      suffixList.sort();

      var suffixStr = '';
      // 数组中包含0则表明没有后缀数字的TAB已经打开、否则不编辑TAB标题直接打开
      if (suffixList.indexOf(0) !== -1) {
        for (var i = 0; i < suffixList.length; i++) {
          // 为-1时跳过
          if (suffixList[i] === -1) {
            continue;
          }

          // 最后一个元素 + 1、左补0
          if (i === suffixList.length - 1) {
            suffixStr = (Array(2).join(0) + (suffixList[i] + 1)).slice(-2);
            break;
          } else {
            // 中间有断号情况、则补号（例如1、3、4）打开的TAB标题为02
            if (suffixList[i] + 1 < suffixList[i + 1]) {
              suffixStr = (Array(2).join(0) + (suffixList[i] + 1)).slice(-2);
              break;
            }
          }
        }
      }

      if (suffixStr !== '') {
        tabPane.title = tabPane.title + '-' + suffixStr;
      }

      tabPanes.push(tabPane);
      if (tabPane && tabPane.notJumpFlag) {
        return Object.assign({}, state, {
          tabPanes: tabPanes.slice()
        });
      } else {
        return Object.assign({}, state, {
          tabPanes: tabPanes.slice(),
          activeKey: tabPane.key
        });
      }

    // 切换 TAB
    case 'CHANGE_TAB_PANE':
      return Object.assign({}, state, {
        activeKey: action.activeKey
      });
    // 删除 TAB
    case 'DELETE_TAB_PANE':
      var key = null;
      // 首页不会关闭，故滤过
      for (let i = 1; i < tabPanes.length; i++) {
        if (tabPanes[i].key === action.targetKey) {
          // 删除的是当前激活的Tab，默认激活前一个TAB
          if (state.activeKey === action.targetKey) {
            key = tabPanes[i - 1].key;
          } else {
            key = state.activeKey;
          }
          tabPanes.splice(i, 1);
          break;
        } else {
          key = state.activeKey;
        }
      }

      return Object.assign({}, state, {
        activeKey: key,
        tabPanes: tabPanes.slice()
      });
    case 'LOG_OUT': {
      const pane = [...tabPanes][0];
      return Object.assign({}, state, pane ? {
        tabPanes: [pane],
        activeKey: pane.key
      } : {});
    }
    default:
      return state;
  }
};

export default tabs;
